/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PriceBookUsage } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
  NumberTypes,
} from '@gh/common-shared';
import { calculatedControlValue } from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { PbDefaults } from '../../../resources/price-book.model';

@Component({
  selector: 'gh-pb-details-defaults-form',
  template: require('./pb-details-defaults-form.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PbDetailsDefaultsFormComponent extends AbstractSnapshotFormComponent<PbDefaults> implements OnInit {
  priceBookUsages: EnumDictionary<PriceBookUsage>;
  totalPct$: Observable<string>;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    const { priceBookUsages } = getRouteInitData(this.route);

    this.priceBookUsages = priceBookUsages;

    super.ngOnInit();

    this.totalPct$ = calculatedControlValue(this.form.group).pipe(
      map$(({ overheadMarkupPct, contingencyMarkupPct, profitMarkupPct }: PbDefaults) => {
        if (isNil(overheadMarkupPct) || isNil(contingencyMarkupPct) || isNil(profitMarkupPct)) {
          return void 0;
        } else {
          return overheadMarkupPct + contingencyMarkupPct + profitMarkupPct;
        }
      }),
      map$((value) => isNil(value) ? '' : NumberTypes.Percents_2.format(value)));
  }

  protected buildForm(snapshot: FormStateSnapshot<PbDefaults>): FormState<PbDefaults> {
    return this.formStateBuilder.buildPlain<PbDefaults>({
      snapshot,
      enabled: this.enabled,
      children: {
        deletePct: { required: true, type: NumberTypes.Percents_2 },
        itemRoundUp: { required: true, type: NumberTypes.RoundUp },
        isQqAllowed: { required: true, type: NumberTypes.Percents_2 },
        qqMarkupPct: { required: true, type: NumberTypes.Percents_2 },
        priceRoundUp: { required: true, type: NumberTypes.RoundUp },
        itemMarkupPct: { required: true, type: NumberTypes.Percents_2 },
        profitMarkupPct: { required: true, type: NumberTypes.Percents_2 },
        componentRoundUp: { required: true, type: NumberTypes.RoundUp },
        overheadMarkupPct: { required: true, type: NumberTypes.Percents_2 },
        componentMarkupPct: { required: true, type: NumberTypes.Percents_2 },
        contingencyMarkupPct: { required: true, type: NumberTypes.Percents_2 },
      },
    });
  }
}
